import { render, staticRenderFns } from "./NetaMultiAttractionDetailsView.vue?vue&type=template&id=495805ef&scoped=true&"
import script from "./NetaMultiAttractionDetailsView.vue?vue&type=script&lang=js&"
export * from "./NetaMultiAttractionDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./NetaMultiAttractionDetailsView.vue?vue&type=style&index=0&id=495805ef&lang=scss&scoped=true&"
import style1 from "./NetaMultiAttractionDetailsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495805ef",
  null
  
)

export default component.exports